import { OrderItxDto, PriceItxDto, ShippingMethodItxDto, ShippingOptionsItxDto, ShoppingCartSellerItemGroupItxDto } from 'src/api/customer';
import { Address } from 'src/api/address';
import { ErrorMessage } from 'src/model/error-message';
// import { Expedition } from 'src/pages/Cart/BasketUserLoged/CheckoutShipping/CheckoutShippingManager';
import { NewExpedition } from 'src/pages/Cart/BasketUserLoged/CheckoutShipping/CheckoutShipping.utils';

export type CheckoutStage = "NONE" | "CART" | "SHIPPING" | "PAYMENT" | "ORDERCONFIRMATION";
export type ExpeditionOriginType = "NACIONAL" | "INTERNACIONAL";
export interface GroupState extends ShoppingCartSellerItemGroupItxDto{
    originType: ExpeditionOriginType,
    sameOriginTypeGroupsIds : number[] | [];
    originCountry: string;
    destinationCountry: string;
    groupKey: string; 
    sameRouteGroupsIds: number[] | [];
    shippingTypesAvailable: {dropPoint: boolean, home: boolean}
    shippingsTypeTotalPrice:{ dropPoint: PriceItxDto | null, home: PriceItxDto | null },
}

export type ADDRESS_ALERTS = 'ADDRESS_WARNING' | 'ADDRESS_ERROR' | null;
export interface AddressAlertErrorData {
    type: ADDRESS_ALERTS;
    addressId?: string | null;
    expeditionIds?: string[];
  }

export interface CheckoutState {
    loading: boolean;
    addresses: Address[];
    addressAlertError?: AddressAlertErrorData | null;  
    expeditions: Record<string, NewExpedition> | null
    groups: GroupState[] | [];
    shippingMethods: ShippingOptionsItxDto[];
    expeditionShippingMethods: Record<string, ShippingMethodItxDto[]> | null;
    shippingAddress: Address | null;
    billingAddress: Address | null;
    shippingMethod: ShippingOptionsItxDto | null;
    order: OrderItxDto | null;
    stage: CheckoutStage;
    completedStage: CheckoutStage;
    error: ErrorMessage | null;
}

export interface OrderConfirmationState {
    order: OrderItxDto | null;
    loading: boolean;
    error: ErrorMessage | null;
}

export const initialCheckoutState: CheckoutState = {
    loading: false,
    addresses: [],
    addressAlertError: null,
    shippingMethods: [],
    shippingAddress: null,
    billingAddress: null,
    shippingMethod: null,
    order: null,
    stage: "NONE",
    completedStage: "NONE",
    error: null,
    expeditions: {},
    groups:[],
    expeditionShippingMethods: null
};


export const initialOrderConfirmationState: OrderConfirmationState = {
    loading: false,
    order: null,
    error: null,
}

